import React from "react";
import Field from "@gqlapp/forms-client-react/FieldAdapter";
import RenderField from "@xem/look/Renders/Field";
import moment from "moment/moment";

export default (function Date(props){
	let values = props?.values || {}
	let label = props?.name || '';
	let required = !!props?.required;
	let name = props?.id;

	let value = values[name];
	let { date_formmat, time_formmat, setFieldValue, onActions } = props || {};

	date_formmat = date_formmat || 'MM/DD/YYYY';
	time_formmat = time_formmat || 'HH:mm:ss';

	function getDatetime(date, time){
		let datetime = `${date} ${time}`;
		return moment(datetime, `${date_formmat} ${time_formmat}`)
	}
	let datetimeValue;

	if(value) {
		if(typeof value !== "undefined"){
			datetimeValue = `${value.format(date_formmat)} - ${value.format(time_formmat)}`;
		}
	}

	const onClick = (e)=>{
		e && e.preventDefault && e.preventDefault();
		func(onActions.date)({
			title: label,
			webType: 'web',
			date: moment(value),
			format: date_formmat,
			onClear: () => setFieldValue(name, ''),
			onChange: function (date){
				func(onActions['time'])({
					webType: 'web',
					date: moment(value),
					format: time_formmat,
					onChange: function (time){
						setFieldValue(name, getDatetime(date, time))
					}
				});
			}
		});
	}

	return <>
		<Field
			{...{ onClick, className: 'Mui-textfield', component: RenderField }}
			{...{ label, name, value: datetimeValue, required }}
			{...{ arrowIcon: { arrowProps:{ onClick } } }}
			{...{
				sx: {
					'& .endAdornment':{
						zIndex: 10,
						position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
						cursor: 'pointer',
						'&> div, &> div > .btn':{
							width: '100% !important',
							height: '100% !important',
						},
						'&> div > .btn':{
							textAlign: 'right',
							paddingRight: '10px !important'
						}
					}
				}
			}}
		/>
	</>
})